@if (!isAdmin) {
<div class="container container-responsive">
  <h2 translate>Administrator role required</h2>
  <p translate>Please contact your administrator to setup the application.</p>
</div>
} @if (isAdmin) {
<div class="container container-responsive">
  @if (!loading) { @if (isSettingsMode && !installationComplete) {
  <div class="fx-row">
    <h1 class="title" translate>Settings</h1>
  </div>
  } @if (!isSettingsMode || installationComplete) {
  <h1 class="title">
    <span translate>Hello</span> <span>{{ name }}</span>
  </h1>
  <h3 translate>Welcome to Auvious setup for Genesys PureCloud</h3>
  }
  <!-- <div class="nav-action" *ngIf="isSettingsMode">
      <button avButton (click)="exit()"><span translate>Exit</span> &rarr;</button>
    </div> -->
  @if (!installationComplete) {
  <div class="wizard">
    @for (step of steps; track step; let i = $index) {
    <div class="wizard-row">
      <div
        class="wizard-step"
        [class.wizard-step-disabled]="
          !isStorageConfigured &&
          step.state === wizardItemStateVisited &&
          step.key === 'recorder'
        "
        (click)="select(step)"
        [ngClass]="{
          'wizard-step-active': step.state === wizardItemStateActive,
          'wizard-step-visited': step.state === wizardItemStateVisited
        }"
      >
        @if (!isSettingsMode) {
        <span>{{ i + 1 }}</span>
        } @if (isSettingsMode && step.state === wizardItemStateActive) {
        <span>&#8722;</span>
        } @if (isSettingsMode && step.state === wizardItemStateVisited) {
        <span>&#43;</span>
        }
      </div>
      <div class="wizard-item">
        @if (step.key === 'integration') {
        <h2 (click)="select(step)" class="wizard-item-title" translate>
          Integration
        </h2>
        @if (step.state === wizardItemStateActive) {
        <p translate>
          Please select the integration instance you would like to setup.
        </p>
        <select name="app" [(ngModel)]="appToInstall">
          @for (app of apps; track app) {
          <option [ngValue]="app">
            {{ app.instance.name }}
          </option>
          }
        </select>
        <div class="margin-top-10">
          @if (i > 0) {
          <button avButton (click)="backStep(i)">
            &larr; <span translate>Back</span>
          </button>
          }
          <button
            avButton
            ofType="stroked"
            (click)="integrationOptionsReady(i)"
          >
            <span translate>Next</span> &rarr;
          </button>
        </div>
        } } @if (step.key === 'finish') {
        <h2 (click)="select(step)" class="wizard-item-title" translate>
          Ready to install
        </h2>
        @if (step.state === wizardItemStateActive) {
        <p translate>Press the following button and the magic will happen.</p>
        <div>
          @if (steps > 1) {
          <button avButton class="margin-right-20" (click)="backStep(i)">
            &larr; <span translate>Back</span>
          </button>
          }
          <button
            avButton
            ofType="stroked"
            id="btn-setup"
            translate
            [disabled]="installing || (apps.length > 1 && !appToInstall)"
            class="btn-transparent"
            (click)="install()"
          >
            Install now
          </button>
        </div>
        } }
      </div>
    </div>
    }
  </div>
  } @if (installationComplete) {
  <p translate>Installation complete</p>
  <p>
    <a [routerLink]="['/welcome']" [queryParams]="queryParams" translate>
      Continue to your application</a
    >
  </p>
  } }
</div>
}
